import React from 'react'
import './style.css'
import { Div, Button } from '@driftt/tide-core'

const ChatButton = () => (
  <Div className="chat-button-container">
    <Button className="chat-button" onClick={ () => window.location.href = "#contact-us" }>Chat with us</Button>
  </Div>
)

export default ChatButton
